import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { notifyListRefresh } from "../../../utils/listNavigation";
import { useDispatch, useSelector } from "react-redux";
import {
	callGenerateCode, callAddAgent,
	callEditAgent, callGetAgentById
} from "../../../api/callcenters/service"
import { AsyncPaginate } from "react-select-async-paginate";
import { callGetAllProvince, callGetDistrict, callGetVehicleBrand, callSearchAgentInfo, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, handleGetCookie, displayUrl, FormatCurrencys, getDeviceId, relation, FormatCurrency, calculateAge, convertStringToJson, dateToString, parseDbValueToArray, encodeBase64 } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import colors from '../../../utils/colors'
import moment from "moment";
import documentType from "../../../data/documentType"
import agentType from "../../../data/agentType"
import { QRCodeCanvas } from 'qrcode.react';
import { subscribeToPubNub } from '../../../utils/pubnubService';
import { toast } from "react-toastify";
import DataAutoComplete from "../../../components/auto-complete";
import { addLifeContract, addVehicleContract, callCheckContractNumber, callGetActivePackage, callGetActiveVehiclePackage, callGetActiveVehicleType, callGetContractByKey, editLifeContract, editVehiclesContract, getLifeContract, getVehiclesContract } from "../../../api/contract/service";
import SwalAlert from "../../../components/common/alert";
import FilterableSelect from "../../../components/common/select-component";
import FilterableDropdown from "../../../components/common/select-component";
import Checkbox from "../../../components/common/checkBox";
import FileUploadGrid from "../../../components/upload-file";
import PaymentPage from "./pay";
import InputNumberFormat from "../../../components/input";
import { callPaymentCheckByBillNumber } from "../../../api/insurances/service";

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [dateOfBirth, setDateOfBirth] = useState(null);
	const [issueDate, setIssueDate] = useState(null);
	const [vehicleBrandList, setVehicleBrandList] = useState([]);
	const [agent, setAgent] = useState([]);
	const saveButtonRef = useRef(null);
	const [agentData, setAgentData] = useState(null);
	const [isStickyVisible, setStickyVisible] = useState(false);
	const debounceTimeout = useRef(null);

	const [request, setRequest] = useState({
		inDebt: false,
		inFree: null,
		signedDate: null,
		contractNumber: null,
		insuranceType: 2,
		package: null,
		packageId: '',
		packageType: '',
		isRenew: 1,
		channel: 'staff on web',
		userId: userInfo?.data?.user?.userId,
		carriedCode: userInfo?.data?.user?.userId,
		carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		deviceId: getDeviceId(),
		isVip: false,
		vipAmount: 0,
		vipPercent: 0,
		guaranteenFeeArray: [],
		guaranteenFee: null,
		discount: 0,
		renew: 0,
		centerAmount: [],
		contractNo: '',
		selectedContractNo: '1',
		vehiclesLegal: 0,
		coverType: '',
		customer: {
			isVerify: '0',
			firstName: '',
			lastName: '',
			gender: 'm',
			dateOfBirth: '',
			age: 30,
			documentTypeId: '',
			documentNo: '',
			issueDate: '',
			expiredDate: '',
			issuePlace: '',
			documentImagePath: null,
			phone: '',
			provinceId: '',
			districtId: '',
			homeNumber: '',
			unitNumber: '',
			village: '',
			file: null
		},
		vehicle: {
			isRenew: 0,
			vehicleBrand: null,
			vehicleBrandId: '',
			vehicleModel: '',
			licensePlate: '',
			vehiclePower: '',
			engineNo: '',
			vehicleIdentificationNo: '',
			imagePath: '',
			isRepairCenter: null,
			file: null
		},

	})
	const [selectedFile, setSelectedFile] = useState(null);
	const fileInputRef = useRef({});

	const [provinceList, setProvinceList] = useState([]);
	const [packageListType, setPackageListType] = useState([]);
	const [packageListTerm, setPackageListTerm] = useState([]);

	const [packageList, setPackageList] = useState([]);

	const [districtList, setDistrictList] = useState({ customer: [], heirs1: [], heirs2: [] });


	const [qrCode, setQRCode] = useState({
		vipAmount: 0,
		discountPercent: 0,
		value: '', transactionId: '', step: 1, total: 0
	});
	let params = useParams();

	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				setRequest((prev) => ({
					...prev, contractNumber: id
				}));
				intialData(id)
			}
		} else {
			if (userInfo?.data?.user?.agentId) setAgentData({ agentCode: (userInfo?.data?.user?.agentId ? userInfo?.data?.user?.agentId : "") })
		}

		setRequest((prev) => ({
			...prev,
			userId: userInfo?.data?.user?.userId,
			carriedCode: userInfo?.data?.user?.userId,
			carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
		}));

		loadProvince();
		loadPackageType()
		const handleScroll = () => {
			if (saveButtonRef.current) {
				const rect = saveButtonRef.current.getBoundingClientRect();
				setStickyVisible(rect.bottom > 980); // ปุ่มหลุดจาก view
			}
		};
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [userInfo]);
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const loadPackageType = async () => {
		const rsp = await dispatch(callGetActiveVehicleType());
		if (rsp?.payload?.responseCode === "00000") {
			setPackageListType(rsp?.payload?.data)
		}
	}
	const loadPackage = async (id) => {
		const rsp = await dispatch(callGetActiveVehiclePackage({ vehiclesTypeId: id }));
		if (rsp?.payload?.responseCode === "00000") {
			const uniqueTerms = [...new Set(rsp?.payload?.data.map(item => item.term))];
			setPackageListTerm(uniqueTerms)
			setPackageList(rsp?.payload?.data)
			return rsp?.payload?.data
		}
		return null
	}
	const loadBrand = async (search, loadedOptions, { page }) => {
		let data = { page: page, maxResult: 10, keyword: search };
		const rsp = await dispatch(callGetVehicleBrand(data));
		if (rsp?.payload?.responseCode === "00000") {
			setVehicleBrandList(rsp.payload.data.result);
			return {
				options: rsp.payload.data.result.map((item) => ({
					value: item.brandId,
					label: item.brandNameEn,
				})),
				hasMore: rsp.payload.data.totalRecords > loadedOptions.length,   // บอกว่ายังมีต่อหรือไม่
				additional: {
					page: page + 1,        // next page
				}
			}
		}
	};
	const intialData = async (id) => {
		const res = await dispatch(getVehiclesContract({ contractNo: id }))
		if (res?.payload?.responseCode === "00000") {
			loadDistrict(res?.payload?.data?.customer.provinceId, 'customer');
			let pk = await loadPackage(res?.payload?.data?.vehicleTypeId)
			if (res?.payload?.data?.agentId) setAgentData({ agentCode: res?.payload?.data?.agentId })
			console.log(res?.payload?.data)
			setRequest((prev) => ({
				...prev,
				...res?.payload?.data,
				customer: res?.payload?.data?.customer,
				vehicle: {
					...res?.payload?.data,
					isRepairCenter: res?.payload?.data?.isRepairCenter,
					imagePath: res?.payload?.data?.imagePath ? convertStringToJson(res?.payload?.data?.imagePath) : ''
				},
				renew: res?.payload?.data?.isRenew,
				inDebt: res?.payload?.data.status === 3,
				packageType: res?.payload?.data?.vehicleTypeId,
				packageId: res?.payload?.data?.packageId,
				package: pk?.find((item) => item.packageId === res?.payload?.data?.packageId),
				userId: userInfo?.data?.user?.userId,
				carriedCode: userInfo?.data?.user?.userId,
				carriedName: userInfo?.data?.user?.firstName + " " + (userInfo?.data?.user?.lastName === null ? '' : userInfo?.data?.user?.lastName),
			}));
		}
	}
	const handleChangeGuaranteenFee = async (e) => {
		const { name, value } = e.target;
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			discount: request.discount,
			guaranteenFee: value,
			step: 1,
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				transactionId: rsp?.payload?.calculate?.transactionId,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				total: rsp?.payload?.calculate?.totalAmount,
				contractNumber: rsp?.payload?.calculate?.contractNumber,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
				...rsp?.payload?.calculate

			})
		}
		setRequest((prev) => ({
			...prev,
			[name]: value
		}))
	};
	const handleChangeCenterAmount = async (e, key) => {
		const { name, value } = e.target;
		if (key) {
			setRequest((prev) => ({
				...prev,
				[key]: {
					...prev[key],
					[name]: name === 'isRepairCenter' ? (e.target.value == "-1" ? null : e.target.value) : value
				}
			})
			);
		}
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? "1" : "0",
			customer: { ...request.customer },
			vehicle: { ...request.vehicle, isRepairCenter: (e.target.value == "-1" ? null : e.target.value) },
			discount: request.discount,
			step: 1,
		}
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				transactionId: rsp?.payload?.calculate?.transactionId,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				total: rsp?.payload?.calculate?.totalAmount,
				contractNumber: rsp?.payload?.calculate?.contractNumber,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
				...rsp?.payload?.calculate

			})
		}
	};
	const handleChangeDiscount = async (e, key) => {
		clearTimeout(debounceTimeout.current);
		const { name, value } = e.target;
		if ((value.replace(/,/g, '') === qrCode.discountPercent) || (!qrCode.discountPercent && value == "0")) {
			return
		}
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? 1 : 0,
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			vipAmount: request.vipAmount,
			discount: value,
			step: 1,
		}
		debounceTimeout.current = setTimeout(async () => {
			{
				console.log(reqUpdate)
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					console.log(rsp?.payload?.calculate)
					setQRCode({
						step: 1,
						transactionId: rsp?.payload?.calculate?.transactionId,
						RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
						priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
						sumTotal: rsp?.payload?.calculate?.sumTotal,
						contractNumber: rsp?.payload?.calculate?.contractNumber,
						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						repairCost: rsp?.payload?.calculate?.repairCost,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
						...rsp?.payload?.calculate

					})
				}
			}
		}, 500);
	};

	const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
	const maxTime = 120;

	const checkPaymentUntilSuccess = async (billNumber, contractNumber) => {
		const maxTimV = maxTime * 1000; // 1 ນາທີ
		const interval = 3 * 1000; // 3 ວິນາທີ
		const startTime = Date.now();

		while (Date.now() - startTime < maxTimV) {
			try {
				const rsp = await dispatch(callPaymentCheckByBillNumber({ billNumber: billNumber }));

				console.log("check payment result:", rsp);

				// ປັບຕາມ response ຂອງ API ເຈົ້າ
				if (rsp?.payload?.responseCode === "00000") {
					let data = { keyword: contractNumber, page: 1, maxResult: 1, insuranceType: 2 };
					const rsp1 = await dispatch(callGetContractByKey(data));
					if (rsp1?.payload?.responseCode === "00000" && rsp1?.payload?.data?.result.length >= 1) {
						notifyListRefresh();
						navigate("/admin/contractControl/vehicleInsurance/detail/" + encodeBase64(JSON.stringify(rsp1.payload.data.result[0])), { replace: true })
						return;
					}
				}
				await sleep(interval);
			} catch (error) {
				console.log("check payment error:", error);
				await sleep(interval);
			}
		}

		return {
			success: false,
			data: null,
			message: __t("uiText.text294")
		};
	};
	const handleChange = (e, key) => {
		let { name, value, type } = e.target;
		// if (['discount', 'vipAmount'].includes(name)) {
		// 	let ss = e.target.value.replace(/,/g, '');
		// 	if (isNaN(ss)) return;
		// 	value = Number(ss).toLocaleString()
		// }

		if (key) {
			setRequest((prev) => ({
				...prev,
				[key]: {
					...prev[key],
					[name]: name === 'isRepairCenter' ? e.target.value : value
				}
			})
			);
			if (name === 'provinceId') {
				loadDistrict(e.target.value, key);
			}
		} else {
			setRequest((prev) => ({
				...prev,
				[name]: name === 'isVip' || name === 'inDebt' ? e.target.checked : value,
				[name === 'isVip' && !e.target.checked ? 'vipAmount' : '']: 0
			}))
		}
	};
	const handleChangeVehicleBrandId = (e) => {
		setRequest((prev) => ({
			...prev,
			vehicle: {
				...prev.vehicle,
				vehicleBrand: e,
				vehicleBrandId: e?.value || ''
			}
		}))
	};
	const onChangePackage = async (e) => {
		setRequest((prev) => ({
			...prev,
			package: e,
			guaranteenFeeArray: parseDbValueToArray(e?.guaranteenFee),
			centerAmount: convertStringToJson(e?.centerAmount) || [],
			packageId: e.packageId,
			isRepairCenter: -1,
			vehiclesLegal: 0,
			vipAmount: 0,
			isVip: false,
			vipPercent: 0,
			guaranteenFee: null

		}))
		let reqUpdate = {
			...request,
			package: e,
			packageId: e.packageId,
			isVip: request.isVip ? 1 : 0,
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			discount: request.discount,
			step: 1
		}
		console.log(reqUpdate)
		const rsp = await dispatch(addVehicleContract(reqUpdate));
		if (rsp?.payload?.responseCode === "00000") {
			setQRCode({
				step: 1,
				RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
				priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
				transactionId: rsp?.payload?.calculate?.transactionId,
				total: rsp?.payload?.calculate?.totalAmount,
				payPerMonth: rsp?.payload?.calculate?.packagePrice,
				feeRegister: rsp?.payload?.calculate?.registerFee,
				total: rsp?.payload?.calculate?.totalAmount,
				contractNumber: rsp?.payload?.calculate?.contractNumber,
				sumTotal: rsp?.payload?.calculate?.sumTotal,
				discount: rsp?.payload?.calculate?.discount,
				vat: rsp?.payload?.calculate?.vat,
				vatValue: rsp?.payload?.calculate?.vatValue,
				paymentFee: rsp?.payload?.calculate?.paymentFee,
				commission: rsp?.payload?.calculate?.commission,
				commissionRate: rsp?.payload?.calculate?.commissionRate,
				vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
				discountPercent: request.discount,
				repairCost: rsp?.payload?.calculate?.repairCost,
				companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
				civelLiability: rsp?.payload?.calculate?.civelLiability,
				guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
				...rsp?.payload?.calculate

			})
		}

	}
	const handleVIP = async (e) => {
		clearTimeout(debounceTimeout.current);
		const { name, value = 0 } = e.target;
		if ((Number(value.replace(/,/g, '')) === qrCode.vipAmount) || (!qrCode.vipAmount && value == "0")) {
			return
		}
		let reqUpdate = {
			...request,
			package: request.package,
			packageId: request.package.packageId,
			isVip: request.isVip ? 1 : 0,
			customer: { ...request.customer },
			vehicle: { ...request.vehicle },
			[name]: e.target.value.replace(/,/g, ''),
			step: 1,
		}
		debounceTimeout.current = setTimeout(async () => {
			{
				console.log(reqUpdate)
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					console.log(rsp?.payload?.calculate)
					setQRCode({
						step: 1,
						transactionId: rsp?.payload?.calculate?.transactionId,
						RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
						priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
						sumTotal: rsp?.payload?.calculate?.sumTotal,
						contractNumber: rsp?.payload?.calculate?.contractNumber,
						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						repairCost: rsp?.payload?.calculate?.repairCost,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
						...rsp?.payload?.calculate

					})
				}
			}
		}, 500);

		// if (key) {
		// 	setRequest((prev) => ({
		// 		...prev,
		// 		[key]: {
		// 			...prev[key],
		// 			[name]: name === 'isRepairCenter' ? e.target.value : value
		// 		}
		// 	})
		// 	);
		// 	if (name === 'provinceId') {
		// 		loadDistrict(e.target.value, key);
		// 	}
		// } else {
		// 	setRequest((prev) => ({
		// 		...prev,
		// 		[name]: name === 'isVip' ? e.target.checked : value
		// 	}))
		// }
	};
	const handleIsVIP = async (e) => {
		clearTimeout(debounceTimeout.current);
		setRequest((prev) => ({
			...prev,
			coverType: e.target.checked ? 'C' : '',
		}))
		if (!e.target.checked) {
			let reqUpdate = {
				...request,
				package: request.package,
				packageId: request.package.packageId,
				isVip: e.target.checked ? 1 : 0,
				customer: { ...request.customer },
				vehicle: { ...request.vehicle },
				step: 1,
			}
			debounceTimeout.current = setTimeout(async () => {
				{
					const rsp = await dispatch(addVehicleContract(reqUpdate));
					if (rsp?.payload?.responseCode === "00000") {
						console.log(rsp?.payload?.calculate)
						setQRCode({
							step: 1,
							transactionId: rsp?.payload?.calculate?.transactionId,
							RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
							priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
							sumTotal: rsp?.payload?.calculate?.sumTotal,
							contractNumber: rsp?.payload?.calculate?.contractNumber,
							total: rsp?.payload?.calculate?.totalAmount,
							payPerMonth: rsp?.payload?.calculate?.packagePrice,
							feeRegister: rsp?.payload?.calculate?.registerFee,
							total: rsp?.payload?.calculate?.totalAmount,
							discount: rsp?.payload?.calculate?.discount,
							vat: rsp?.payload?.calculate?.vat,
							vatValue: rsp?.payload?.calculate?.vatValue,
							commission: rsp?.payload?.calculate?.commission,
							commissionRate: rsp?.payload?.calculate?.commissionRate,
							vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
							discountPercent: request.discount,
							paymentFee: rsp?.payload?.calculate?.paymentFee,
							repairCost: rsp?.payload?.calculate?.repairCost,
							companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
							civelLiability: rsp?.payload?.calculate?.civelLiability,
							guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
							...rsp?.payload?.calculate
						})
					}
				}
			}, 500);
		}
	};

	const selectedDistrict = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				districtId: e.target.value
			}
		}));
	}

	const loadDistrict = async (proId, key) => {
		const rs = await dispatch(callGetDistrict({ provinceId: proId }));
		if (rs?.payload?.responseCode === "00000") {
			console.log(key)
			setDistrictList((prev) => ({
				...prev,
				[key]: rs?.payload?.data
			}))
		}
	}

	const selectedDocument = (e) => {
		e.preventDefault();
		setRequest((prev) => ({
			...prev,
			customer: {
				...prev.customer,
				documentTypeId: e.target.value
			}
		}));
	}

	const selectePackageType = async (e) => {
		e.preventDefault();
		if (!e.target.value) {
			setRequest((prev) => ({
				...prev,
				packageId: "",
				packageType: "",
				isRepairCenter: -1,
				vehiclesLegal: 0,
				vipAmount: 0,
				isVip: false,
				vipPercent: 0,
				guaranteenFee: null
			}));
			return
		}
		setRequest((prev) => ({
			...prev,
			packageType: e.target.value,
			isRepairCenter: -1,
			vehiclesLegal: 0,
			vipAmount: 0,
			isVip: false,
			vipPercent: 0,
			guaranteenFee: null

		}));
		loadPackage(e.target.value)
	}

	const handleSave = async (e) => {
		e.preventDefault()
		if (!request.guaranteenFee && request.guaranteenFeeArray.length > 0) {
			SwalAlert.error(__t("uiText.text023"), __t("uiText.text296"));
			return;
		}
		SwalAlert.confirmInput(t("nameSave"), t("confirmSave"), request.inFree == 1, async (input) => {
			try {
				if (request.contractNumber) {
					let imagePath = JSON.stringify(request.vehicle.imagePath)
					let error = null

					if (request.vehicle?.file?.file) {
						const upload = await dispatch(callUploadFile(request.vehicle?.file?.file));
						if (upload?.payload?.responseCode === "00000") {
							imagePath = JSON.stringify([...request.vehicle.imagePath, ...upload?.payload?.data])
						} else {
							error = t('uploadFile.vehicle') + " " + upload?.payload?.responseCode
						}
					}
					if (error != null) {
						SwalAlert.error(__t("uiText.text023"), error);
						return
					}
					let body = {
						...request,
						vehicle: { ...request.vehicle, imagePath: imagePath, isRenew: request.renew },
					}
					const rsp = await dispatch(editVehiclesContract(body));
					if (rsp?.payload?.responseCode === "00000") {
						notifyListRefresh();
						navigate('/admin/contractControl/vehicleInsurance')
					} else {
						SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
					}
					return
				}
				let error = null
				let documentImagePath = ""
				let imagePath = ""
				if (request.vehicle.file !== null) {
					const upload = await dispatch(callUploadFile(request.vehicle.file.file));
					if (upload?.payload?.responseCode === "00000") {
						imagePath = JSON.stringify(upload?.payload?.data)
					} else {
						error = t('uploadFile.vehicle') + " " + upload?.payload?.responseCode

					}
				}
				if (error != null) {
					SwalAlert.error(__t("uiText.text023"), error);
					return
				}
				let reqUpdate = {
					...request,
					isVip: request.isVip ? 1 : 0,
					inDebt: request.inDebt ? 1 : null,
					customer: { ...request.customer, documentImagePath },
					vehicle: { ...request.vehicle, imagePath },
					vipAmount: request.vipAmount,
					FreeNote: input,
					step: 2
				}
				const rsp = await dispatch(addVehicleContract(reqUpdate));
				if (rsp?.payload?.responseCode === "00000") {
					if (request.inDebt) {
						let data = { keyword: rsp?.payload?.calculate?.contractNumber, page: 1, maxResult: 1, insuranceType: 2 };
						const rsp1 = await dispatch(callGetContractByKey(data));
						if (rsp1?.payload?.responseCode === "00000" && rsp1?.payload?.data?.result.length >= 1) {
							notifyListRefresh();
							navigate("/admin/contractControl/vehicleInsurance/detail/" + encodeBase64(JSON.stringify(rsp1.payload.data.result[0])), { replace: true })
							return;
						}
					}
					if (request.inFree) {
						let data = { keyword: rsp?.payload?.calculate?.contractNumber, page: 1, maxResult: 1, insuranceType: 2 };
						const rsp1 = await dispatch(callGetContractByKey(data));
						if (rsp1?.payload?.responseCode === "00000" && rsp1?.payload?.data?.result.length >= 1) {
							notifyListRefresh();
							navigate("/admin/contractControl/vehicleInsurance/detail/" + encodeBase64(JSON.stringify(rsp1.payload.data.result[0])), { replace: true })
							return;
						}
					}
					setQRCode({
						step: 2,
						value: rsp?.payload?.data,
						transactionId: rsp?.payload?.calculate?.transactionId,
						total: rsp?.payload?.calculate?.totalAmount,
						payPerMonth: rsp?.payload?.calculate?.packagePrice,
						feeRegister: rsp?.payload?.calculate?.registerFee,
						total: rsp?.payload?.calculate?.totalAmount,
						discount: rsp?.payload?.calculate?.discount,
						vat: rsp?.payload?.calculate?.vat,
						contractNumber: rsp?.payload?.calculate?.contractNumber,
						vatValue: rsp?.payload?.calculate?.vatValue,
						commission: rsp?.payload?.calculate?.commission,
						commissionRate: rsp?.payload?.calculate?.commissionRate,
						vipAmount: rsp?.payload?.calculate?.vipAmount || 0,
						discountPercent: request.discount,
						repairCost: rsp?.payload?.calculate?.repairCost,
						paymentFee: rsp?.payload?.calculate?.paymentFee,
						companyReceiveTotal: rsp?.payload?.calculate?.companyReceiveTotal,
						civelLiability: rsp?.payload?.calculate?.civelLiability,
						guaranteenFee: rsp?.payload?.calculate?.guaranteenFee,
						sumTotal: rsp?.payload?.calculate?.sumTotal,
						RVPEAmount: rsp?.payload?.calculate?.RVPEAmount,
						priceAfterDiscount: rsp?.payload?.calculate?.priceAfterDiscount,
						...rsp?.payload?.calculate

					})

					const check = await checkPaymentUntilSuccess(rsp?.payload?.calculate?.billNumber, rsp?.payload?.calculate?.contractNumber)
					if (!check.success) {
						notifyListRefresh();
						navigate('/admin/contractControl/vehicleInsurance')
						return {
							success: true,
							data: null,
							message: ""
						};
					}

				} else {
					SwalAlert.error(__t("uiText.text023"), rsp?.payload?.responseCode + " - " + rsp?.payload?.responseDescription);
				}
			} catch (error) {
				SwalAlert.error(__t("uiText.text023"), error,);
			}
		})

	}

	const triggerFileInput = (key) => {
		fileInputRef.current[key].click();

	};

	const cancelSeletedFile = (key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: null
			}
		}));
	};


	const handleImageSelect = (e, key) => {
		setRequest((prev) => ({
			...prev,
			[key]: {
				...prev[key],
				file: { file: e }
			}
		}));
	};
	const handleDateChange = (date, field) => {
		setRequest((prev) => ({
			...prev,
			[field]: moment(date).format('YYYY-MM-DD'),
		}));
	};
	const loadData = async (value) => {
		if (value?.id) {
			let data = { keyword: '', page: 1, maxResult: 10, agentId: value?.id, type: 2 };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}
		} else {
			let data = { keyword: value, page: 1, maxResult: 10, agentId: null, type: 2 };
			const rsp = await dispatch(callSearchAgentInfo(data));
			if (rsp?.payload?.responseCode === "00000" && rsp?.payload?.data?.result.length >= 1) {
				setAgent(rsp.payload.data.result)
			}
		}
	};

	const onSelect = async (item) => {
		if (item) {
			setRequest((prev) => ({
				...prev,
				agent: item,
				agentId: item.agentId
			}));
		} else {
			setRequest((prev) => ({
				...prev,
				agent: null,
				agentId: null
			}));
		}
	}

	const selectedContractNoOption = (e) => {
		const v = e.target.value; // "1" or "2"
		setRequest((prev) => ({
			...prev,
			selectedContractNo: v

		}));
	};
	const checkContactNumber = async (e) => {
		if (e.target.value) {
			const rs = await dispatch(callCheckContractNumber({ contractNo: e.target.value }));
			if (rs?.payload?.responseCode === "10430") {
				SwalAlert.error("", t('errors.contractNumberExists'))
			}
		}
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<form onSubmit={handleSave}>
				<section className="user-dashboard">
					<div className="dashboard-outer">
						<div className="upper-title-box back-title-group">
							<BackPrevious />
							<h4>{Object.keys(params).length > 0 ? t("contracts.edit") : t("contracts.add")}</h4>
						</div>
						<div className="ls-widget">
							<div className="tabs-box">
								<div className="widget-content p-4">
									<div className="default-form">
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.life.customer")} {request.vehicle.createDate ? (t("contracts.vehicle.createDate") + ":" + dateToString(request.vehicle.createDate, 'DD/MM/YYYY')) : ''}</h5><hr /></div>
											<div className="col-md-3 form-group">
												<label> {t('selectedContractNo')} <span className="text-danger">*</span> </label>
												<select
													disabled={request.contractNumber != null}
													className="chosen-single form-select"
													name="selectedContractNo"
													onChange={selectedContractNoOption}
													value={request.selectedContractNo || "1"}
													required
												>
													<option value="1">{t("auto")}</option>
													<option value="2">{t("manual")}</option>
												</select>

											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.contractNumber')}
													{
														request.selectedContractNo === "1" ? "" : <span className="text-danger">*</span>
													}
												</label>
												<input
													type="text"
													name="contractNo"
													className="form-control-uld"
													placeholder={t('contracts.life.contractNumber')}
													onChange={(e) => handleChange(e, null)}
													value={request.contractNo}
													autoComplete="off"
													onBlur={checkContactNumber}
													disabled={request.selectedContractNo === "1" || request.contractNumber != null}
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.agentCode')}<span className="text-danger">*</span></label>
												<DataAutoComplete
													disabled={request.contractNumber != null}
													label="firstName"
													id="agentCode"
													initialData={agentData}
													data={agent}
													autoSelect={true}
													placeholder={t('contract.keyword')}
													handleChange={loadData}
													onSelect={onSelect}
												/>
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.life.firstName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="firstName"
													className="form-control-uld"
													placeholder={t('contracts.life.firstName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.firstName}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-3 form-group">
												<label> {t('contracts.life.lastName')}<span className="text-danger">*</span></label>
												<input
													type="text"
													name="lastName"
													className="form-control-uld"
													placeholder={t('contracts.life.lastName')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.lastName}
													autoComplete="off"
													required />
											</div>
											<div className="col-md-3 form-group">
												<label> {t('contracts.vehicle.signedDate')}</label>
												<DatePicker
													// minDate={new Date()}
													disabled={request.contractNumber != null}
													selected={request.signedDate}
													onChange={(date) => handleDateChange(date, 'signedDate', null)}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.vehicle.signedDate')}
													className="form-control-uld"
												/>
											</div>

											{/* <div className="col-md-2 form-group">
												<label> {t('contracts.life.dateOfBirth')} <span className="text-danger">*</span> </label>
												<DatePicker
													selected={request.customer?.dateOfBirth}
													onChange={(date) => handleDateChange(date, 'dateOfBirth', "customer")}
													dateFormat="dd/MM/yyyy"
													placeholderText={t('contracts.life.dateOfBirth')}
													className="form-control-uld"
													required
												/>
											</div> */}

											{/* <div className="col-md-2 form-group">
												<label>{t('contracts.life.gender')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="gender"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.gender}
													required
												>
													<option key={"m"} value={"m"}>{t("gender.m")}</option>
													<option key={"f"} value={"f"}>{t("gender.f")}</option>
												</select>
											</div> */}

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.phone')} <span className="text-danger">*</span> </label>
												<input
													type="number"
													name="phone"
													className="form-control-uld"
													placeholder={t('contracts.life.phone')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.phone}
													autoComplete="off"
													required />
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.provinceName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="provinceId"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.provinceId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														provinceList.map((item) => (
															<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
														))
													}
												</select>
											</div>

											<div className="col-md-2 form-group">
												<label> {t('contracts.life.districtName')} <span className="text-danger">*</span> </label>
												<select className="chosen-single form-select"
													name="districtId"
													onChange={selectedDistrict}
													value={request.customer?.districtId}
													required
												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{
														districtList['customer'].map((item) => (
															<option key={item.districtId} value={item.districtId}>{item.districtName}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-2 form-group">
												<label> {t('contracts.life.village')} <span className="text-danger">*</span> </label>
												<input
													type="text"
													name="village"
													className="form-control-uld"
													placeholder={t('contracts.life.village')}
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.village}
													autoComplete="off" />
											</div>
											<div className="col-md-2 form-group">
												<label>{t('contracts.life.isVerify')}<span className="text-danger">*</span></label>
												<select className="chosen-single form-select"
													name="isVerify"
													onChange={(e) => handleChange(e, "customer")}
													value={request.customer?.isVerify}
													disabled={request.customer?.oldVerify === 1}
													style={request.customer.oldVerify === 1 ? { color: colors.primary } : {}}
													required
												>
													<option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option>
												</select>
											</div>
											{/* <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.inDebt')}</label>
												<Checkbox
													disabled={request.contractNumber != null}
													label={t('contracts.vehicle.inDebt')}
													checked={request.inDebt}
													name='inDebt'
													onChange={(e) => handleChange(e, null)}
												/>
											</div> */}
											<div className="col-md-4 form-group">
												<label>{t('contracts.life.packageType')} <span className="text-danger">*{!request.agentId ? t("uiLabels.selectAgentFirst") : ""}</span> </label>
												<select className="chosen-single form-select"
													name="packageType"
													onChange={selectePackageType}
													value={request?.packageType}
													required
													disabled={request.contractNumber || !request.agentId}

												>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{

														packageListType.map((item) => (
															<option key={item.id} value={item.id}>{item.nameLa}</option>
														))
													}
												</select>
											</div>
											<div className="col-md-4 form-group">
												<label>{t('contracts.life.package')} <span className="text-danger">*</span> </label>
												{/* <FilterableDropdown
													isDisabled={request.contractNumber}
													options={packageList}
													label={'optionNameLa'}
													valueKey={'packageId'}
													type={packageListTerm}
													value={request?.package}
													onChange={onChangePackage}
													typeDefault={0}
													filteredTypeInput={request?.packageType}
												/> */}
												<FilterableDropdown
													isDisabled={request.contractNumber}
													options={packageList}
													value={request?.package}
													onChange={onChangePackage}
													label="optionNameLa"
													valueKey="packageId"
												/>
											</div>
											{request.centerAmount.length > 0 && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.isRepairCenter')}</label>
												<select className="chosen-single form-select"
													name="isRepairCenter"
													onChange={(e) => handleChangeCenterAmount(e, "vehicle")}
													value={request.vehicle?.isRepairCenter}
												>
													<option key={0} value={-1}>{t("contracts.vehicle.isRepairCenter")}</option>
													{request.centerAmount?.map((center, index) => (
														<option key={index} value={index}>{FormatCurrencys(center)}</option>
													))}
													{/* <option key={0} value={0}>{t("verifyStatus.notVerify")}</option>
													<option key={1} value={1}>{t("verifyStatus.verify")}</option> */}
												</select>
												{/* <Checkbox
													disabled={request.contractNumber}
													label={t('contracts.vehicle.isRepairCenter')}
													checked={request.vehicle.isRepairCenter}
													name='isRepairCenter'
													onChange={(e) => handleChange(e, "vehicle")}
												/> */}
											</div>}
											{request.package?.isVip == 1 && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.vip')}</label>
												<Checkbox
													disabled={request.contractNumber}
													label={t('contracts.vehicle.vip')}
													checked={request.isVip}
													name='isVip'
													onChange={(e) => {
														handleChange(e, null)
														handleIsVIP(e)
													}}
												/>
											</div>}
											{request.isVip && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.carType')}</label>
												<select className="chosen-single form-select"
													name="vehiclesLegal"
													onChange={(e) => handleChange(e)}
													value={request.vehiclesLegal}
												>
													<option key={0} value={0}>{t("car.vehicleWithDoc")}</option>
													<option key={1} value={1}>{t("car.vehicleWithOutDoc")}</option>
												</select>
											</div>}
											{request.isVip && <div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.coverType')}</label>
												<select className="chosen-single form-select"
													name="coverType"
													onChange={(e) => handleChange(e)}
													value={request.coverType}
												>
													<option key={0} value={'C'}>C</option>
													<option key={1} value={'D'}>D</option>
												</select>
											</div>}
											{request.isVip &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.vipPercent')} <span className="text-danger">*</span> </label>
													<input
														type="number"
														name="vipPercent"
														className="form-control-uld"
														placeholder={t('contracts.vehicle.vipPercent')}
														onChange={(e) => handleChange(e.target.value > 10 ? { target: { value: 10, name: 'vipPercent' } } : e, null)}
														onBlur={
															request.vipAmount > 0 ? handleVIP : null
														}
														value={request.vipPercent}
													/>
												</div>}
											{request.isVip &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.vipAmount')} <span className="text-danger">*</span> </label>
													<InputNumberFormat
														type="text"
														min={0}
														name="vipAmount"
														className="form-control-uld"
														placeholder={t('contracts.vehicle.vipAmount')}
														onChange={(e) => handleChange(e, null)}
														onBlur={
															request.vipPercent > 0 ? handleVIP : null
														}
														value={request.vipAmount}
														autoComplete="off" />
												</div>}
											{request?.guaranteenFeeArray?.length > 0 &&
												<div className="col-md-2 form-group">
													<label>{t('contracts.vehicle.guaranteenFee')}</label><span className="text-danger">*</span>
													<select className="chosen-single form-select"
														name="guaranteenFee"
														onChange={(e) => handleChangeGuaranteenFee(e)}
														value={request.guaranteenFee}
													>
														<option key={0} value={''}>{t("pleaseSelect")}</option>
														{request.guaranteenFeeArray?.map((item, index) => (
															<option key={index} value={index}>{FormatCurrencys(item)}</option>
														))}
													</select>
												</div>}
											{request?.package?.discount == 1 &&
												<div className="col-md-2 form-group">
													<label> {t('contracts.vehicle.discount')} </label>
													<input
														type="number"
														name="discount"
														minLength={0}
														maxLength={100}
														className="form-control-uld"
														placeholder={t('contracts.vehicle.discount')}
														onChange={(e) => handleChange(e, null)}
														onBlur={(e) => {
															handleChangeDiscount(e, null)
														}}
														disabled={request.contractNumber}
														value={request.discount}
														autoComplete="off" />
												</div>}
											<div className="col-md-2 form-group">
												<label>{t('contracts.vehicle.contractType')}</label>
												<select className="chosen-single form-select"
													name="renew"
													onChange={(e) => handleChange(e)}
													value={request.renew}
												>
													<option key={0} value={0}>{t("contracts.vehicle.new")}</option>
													<option key={1} value={1}>{t("contracts.vehicle.renew")}</option>
												</select>
											</div>
											<div className="col-md-2 form-group">

											</div>
										</div>
										<div className="row">
											<div className="col-12 mb-3"><h5 className="fw-bold">#{t("contracts.vehicle.info")}</h5><hr /></div>
											{/* <div className="col-12 mt-4"><h5>{t("contracts.vehicle.info")}</h5><hr /></div> */}
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleBrand")}<span className="text-danger">*</span></label>
												{/* <select className="form-select" name="vehicleBrandId" value={request.vehicle.vehicleBrandId} required onChange={(e) => handleChange(e, "vehicle")}>
													<option key={0} value="">{t("pleaseSelect")}</option>
													{vehicleBrandList?.map(item => (<option value={item.brandId}>{item.brandNameEn}</option>))}
												</select> */}

												<AsyncPaginate
													styles={{
														control: (base, state) => ({
															...base,
															minHeight: 45,
															height: 45,
															background: "#f0f5f7",
															borderColor: state.isFocused
																? "var(--primary-color)"
																: base.borderColor,
															boxShadow: state.isFocused
																? "0 0 0 0.5px var(--primary-color)"
																: "none",
															"&:hover": {
																borderColor: "var(--primary-color)",
															},
														}),
														valueContainer: (base) => ({
															...base,
															height: 45,
															padding: "0 8px",
															fontSize: "14px",
															display: "flex",
															alignItems: "center",   // ✅ ทำให้ placeholder / input อยู่กลางแนวตั้ง
														}),
														input: (base) => ({
															...base,
															margin: 0,
															padding: 0,
															fontSize: "14px",
															alignSelf: "center",    // ✅ จัด input ให้อยู่กลาง
														}),
														placeholder: (base) => ({
															...base,
															margin: 0,
															fontSize: "14px",
															color: "#999",
															position: "absolute",
															top: "50%",
															transform: "translateY(-50%)", // ✅ จัด placeholder ให้อยู่กลางแนวตั้ง
														}),
														menuList: (base) => ({
															...base,
															fontSize: "14px",
															maxHeight: 200,
														}),
													}}
													name="vehicleBrandId"
													value={request.vehicle.vehicleBrand}
													loadOptions={loadBrand}
													onChange={handleChangeVehicleBrandId}
													additional={{
														page: 1,
													}}
													debounceTimeout={500}
													placeholder={t("contracts.vehicle.vehicleBrand")}
													isClearable
												/>

											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleModel")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehicleModel')} name="vehicleModel" value={request.vehicle?.vehicleModel} required onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.licensePlate")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.licensePlate')} name="licensePlate" value={request.vehicle?.licensePlate} required onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehiclePower")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehiclePower')} name="vehiclePower" value={request.vehicle.vehiclePower} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.engineNo")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.engineNo')} name="engineNo" required value={request.vehicle.engineNo} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-md-2 form-group">
												<label>{t("contracts.vehicle.vehicleIdentificationNo")}<span className="text-danger">*</span></label>
												<input className="form-control-uld" placeholder={t('contracts.vehicle.vehicleIdentificationNo')} required name="vehicleIdentificationNo" value={request.vehicle.vehicleIdentificationNo} onChange={(e) => handleChange(e, "vehicle")} />
											</div>
											<div className="col-12 col-md-12 form-group">
												<label> {t('contracts.vehicle.imagePath')} <span className="text-danger">*</span> </label>
												<FileUploadGrid
													multiple={true}
													folderName="vehicle"
													filesFromApi={request.vehicle.imagePath || []}
													onChange={(e) => handleImageSelect(e, 'vehicle')}
													accept="image/*,application/pdf"
													required
												/>
											</div>
										</div>

										{
											qrCode.step == 1 && request.contractNumber != null ? <div className="col-12 d-flex justify-content-center">
												<div className="m-3" ref={saveButtonRef}>
													<button className="theme-btn btn-style-one w-100" type="submit">
														<i className="fas fa-add"></i>&nbsp;{t("button.save")}
													</button>
												</div>
											</div> : null
										}
									</div>
								</div>
							</div>
						</div>
						{
							qrCode.total ?
								<div className="ls-widget">
									<div className="tabs-box">
										<div className="widget-content p-4">
											<div className="default-form">
												<div className="row">
													<PaymentPage countdownSeconds={maxTime} isDebit={request?.agent?.debit !== 1} onPay={(data) => {

														setRequest((prev) => ({
															...prev,
															inDebt: data.inDebt,
															inFree: data.inFree
														}))
														saveButtonRef.current?.click()
													}} FormatCurrencys={FormatCurrencys} t={t} qrCode={qrCode} />
												</div>
											</div>
										</div>
									</div>
								</div> : null
						}
					</div>
				</section>
			</form>
			<CopyrightFooter />
		</div >
	);
};

export default Index;
